import React, { useEffect, useState } from 'react';
import { AdminSelect } from '@project/components';
import axios from '../../utils/axios';
import { useIntl } from 'react-intl';

function PropertySelect({ selectedCompany, selectedProperty, setSelectedProperty, selectClass }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProperties = async () => {
      setSelectedProperty(null);
      setProperties([]);
      if (!selectedCompany) return;
      setIsLoading(true);
      const result = await axios.get(`/properties?company=${encodeURIComponent(selectedCompany.value)}`);
      const propertyOptions = result.data.records
        .filter(_ => _.status === 'active')
        .map(({ name, displayName, address1, city, state, postal, latitude, longitude, idpRecordId }) => ({
          value: name,
          label: displayName || name,
          address: address1 || city || state || postal ? `${address1 || ''}, ${city || ''}, ${state || ''} ${postal || ''}` : null,
          city,
          address1,
          state,
          postal,
          displayName,
          latitude,
          longitude,
          idpRecordId
        }));
      setIsLoading(false);
      setProperties(propertyOptions);
    }
    fetchProperties();
  }, [selectedCompany, setSelectedProperty]);

  return (
    <AdminSelect label={t('term.property')}
      defaultValue=""
      value={selectedProperty}
      onChange={setSelectedProperty}
      options={properties}
      loadingMessage={t('CompanySelect.loadingMessage')}
      noOptionsMessage={t('CompanySelect.noOptions')}
      placeholder={isLoading ? `${t('ui.loading')}...` : t('PropertySelect.selectProperty')}
      isLoading={isLoading}
      identifierClass={ !isLoading ? 'data-property-select' : ''}
    />
  )
}

export default PropertySelect;